var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("v-page-header", { attrs: { title: _vm.getPageTile } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.loadingError) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLoadingError,
                expression: "!hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "grid-x" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell medium-9 medium-offset-1 large-11 large-offset-0",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrapper" },
                      [
                        _c("v-action-buttons", {
                          attrs: { items: _vm.getActionButtons },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "box" },
                          [
                            _c("v-navigation"),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                staticClass: "filter filter--search",
                                attrs: {
                                  action: "",
                                  method: "POST",
                                  novalidation: "",
                                },
                                on: { submit: _vm.onChangePmsTableFilter },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--search",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pmsTableFilter.search,
                                          expression: "pmsTableFilter.search",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control--small form-control--search",
                                      attrs: {
                                        type: "text",
                                        name: "search",
                                        placeholder: _vm.$t("search.term"),
                                      },
                                      domProps: {
                                        value: _vm.pmsTableFilter.search,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.pmsTableFilter,
                                            "search",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        attrs: {
                                          role: "button",
                                          type: "submit",
                                          title: _vm.$t("search"),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(_vm.$t("search")) +
                                            "\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-table", {
                              attrs: {
                                isLoading: _vm.pmsTableLoading,
                                columns: _vm.pmsTableColumns,
                                items: _vm.pmsTableItems,
                                showShowAll: false,
                                showShowDeactivatedOnly: true,
                                showDeactivatedOnly:
                                  _vm.pmsTableFilter.show_deactivated_only,
                              },
                              on: {
                                onChangeShowDeactivatedOnly:
                                  _vm.onChangeShowDeactivatedOnlyPmsTableFilter,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "name",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "table-label" },
                                        [_vm._v(_vm._s(row.profile.lastname))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "table-description" },
                                        [_vm._v(_vm._s(row.profile.firstname))]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "phone",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "table-label" },
                                        [
                                          row.profile.communication.mobile
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    row.profile.communication
                                                      .mobile
                                                  )
                                                ),
                                              ]
                                            : [_vm._v("-")],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "table-description" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("customers.pm.mobile")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "location",
                                  fn: function ({ row }) {
                                    return [
                                      row.location
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "table-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.location.company_name
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "table-description",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(row.location.city)
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "update",
                                  fn: function ({ row }) {
                                    return [
                                      _vm.$store.getters.userHasPermission(
                                        "pm_update"
                                      )
                                        ? [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "button button--action button--action--edit button--small",
                                                attrs: {
                                                  to: {
                                                    name: "customers-update-customer-pm",
                                                    params: {
                                                      custumor:
                                                        _vm.$route.params
                                                          .customer,
                                                      account: row.id,
                                                    },
                                                  },
                                                  title: _vm.$t("update"),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(_vm.$t("update")) +
                                                    "\n                                            "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("v-pagination", {
                              attrs: {
                                currentPage: _vm.pmsTableCurrentPage,
                                itemsPerPage: _vm.pmsTableItemsPerPage,
                                items: _vm.pmsTableItemsCount,
                              },
                              on: { pageClicked: _vm.onChangePmsTablePage },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }